module.exports = __webpack_public_path__ + "img/lg_ring_g_i_null_1.4796a3b9.png";